import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ClientNotesService {

  constructor(
    private baseClient: BaseclientService,
  ) { }

  getNotes(dateFrom?: string|any, dateTo?: string|any, merchantId?: number|any): Observable<any> {
 
    const params = {
      date_from: dateFrom,
      date_to: dateTo,
      merchant_id: merchantId
    }
    return from(this.baseClient.postBase("getNotes", params)).pipe(
      map(data => data.client_notes)
    )
  }

  

  

}
